export default __webpack_public_path__ + "static/training-a11y-a329ebc5ce93763f97a227ab6a79c3508e5d1093e2056a8cb485eef6b566a752.png";